import { createAction, props } from '@ngrx/store';
import { ProfileState } from 'src/app/store/reducers/profile.reducer';

export const set_profile         = createAction('[Profile] Set Profile', props<{ profile: ProfileState }>());
export const update_profile      = createAction('[Profile] Update Profile', props<{ profile: ProfileState }>());
export const set_current_auction = createAction('[Profile] Set Current Auction', props<{ uid: string }>());
export const clear_profile       = createAction('[Profile] Clear Profile');